import { formatCoin, formatDate } from '@polaris/core/utils'
import { useAtomValue } from 'jotai'
import { useState } from 'react'
import { routeMachineSnapshotAtom } from '@/src/stores/route-machine/atoms'
import { cn } from '@/src/utils/styles'
import { ChainImg } from '../ui/chain-img'
import TokenImg from '../ui/token-img'
import { BasicStep } from './basic-step'

export const RecoveryStep = () => {
  const snapshot = useAtomValue(routeMachineSnapshotAtom)

  if (!snapshot.hasTag('aborting')) return null

  const refundInfo = snapshot.context.refundInfo
  const isDoingRecoveryTx =
    snapshot.hasTag('loading') && snapshot.hasTag('aborting')

  // Auto recovery mode - backend initiated
  if (refundInfo && isDoingRecoveryTx) {
    return (
      <BasicStep title='Trade failed' isLoading={true} isError={true}>
        <div className='flex flex-col text-left gap-2'>
          <div className='font-semibold text-primary text-xl flex items-center gap-2'>
            <span className='text-tertiary'>Recovering as </span>
            <div className='flex items-center gap-1.5'>
              <TokenImg
                src={refundInfo.assetImg}
                ticker={refundInfo.ticker}
                width={24}
                height={24}
                className='size-6 rounded-full'
                fallbackContainerClassName='size-6'
                unoptimized
              />
              <span className='text-primary'>{refundInfo.ticker}</span>
            </div>
          </div>
          <div className='text-secondary text-sm leading-6'>
            About <span className='text-primary'>a few</span> seconds to
            complete
          </div>
        </div>
      </BasicStep>
    )
  }

  return null
}

export const RecoverySuccessStep = () => {
  const snapshot = useAtomValue(routeMachineSnapshotAtom)
  const refundInfo = snapshot.context.refundInfo
  const failedStep = snapshot.context.route?.getStep(
    snapshot.context.currentStep,
  )
  const [now] = useState(new Date())

  if (!refundInfo || !failedStep) return null

  return (
    <li className='flex flex-col justify-center items-center gap-2 min-h-full overflow-hidden'>
      <div className='text-center'>
        <p className='text-success-text font-semibold'>Funds recovered</p>
        <p className='text-secondary text-sm tracking-tight'>
          {formatDate(now, undefined, {
            dateStyle: 'medium',
            timeStyle: 'short',
          })}
        </p>
      </div>
      <div className='relative my-6'>
        {!!refundInfo.assetImg && (
          <TokenImg
            src={refundInfo.assetImg}
            ticker={refundInfo.ticker}
            width={64}
            height={64}
            className='size-16 rounded-full'
            unoptimized
          />
        )}
        {!!failedStep.from_chain.chain_img && (
          <div
            className={cn(
              'absolute bottom-0 right-0 border-3 bg-foreground border-foreground rounded-[8px] flex items-center justify-center',
            )}
          >
            <ChainImg
              chainImg={failedStep.from_chain.chain_img}
              chainName={failedStep.from_chain.chain_name}
              chainId={failedStep.from_chain.chain_id}
              unoptimized
              size='md'
            />
          </div>
        )}
      </div>
      <h6 className='text-primary font-semibold text-xl'>
        {formatCoin({
          amount: Number(refundInfo.amount),
          denom: refundInfo.ticker,
        })}
      </h6>
    </li>
  )
}
